/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { PropertyFeatures } from '@zcode/enums'
import type { Filters } from '@zcode/state-type'

export const mapOtherFilters = (filters: Filters) => {
  const other: string[] = []
  const {
    availableBefore,
    hasVirtualTours,
    features,
    noFees,
    maxDays,
    maxPricePerBedroomPercentile,
    minPricePerBedroomPercentile,
    hasImages,
    hideNoVacancy,
    minSquareFeet,
  } = filters

  if (hasVirtualTours) {
    other.push('3D Tour or Video Tour')
  }
  if (features.includes(PropertyFeatures.LIVE_VIRTUAL_TOUR)) {
    other.push('Live Online Tours')
  }
  if (noFees) {
    other.push('No leasing fee')
  }
  if (features.includes(PropertyFeatures.STUDENT_HOUSING)) {
    other.push('Student Housing')
  }
  if (features.includes(PropertyFeatures.SENIOR_LIVING)) {
    other.push('Senior Living')
  }
  if (features.includes(PropertyFeatures.INCOME_RESTRICTED)) {
    other.push('Income Restricted')
  }
  if (features.includes(PropertyFeatures.UTILITIES_INCLUDED)) {
    other.push('Utilities Included')
  }
  if (features.includes(PropertyFeatures.SPECIALS)) {
    other.push('Move-in Special')
  }
  if (features.includes(PropertyFeatures.NO_SECURITY_DEPOSIT)) {
    other.push('No Security Deposit')
  }
  if (features.includes(PropertyFeatures.DIRECT_DEAL)) {
    other.push('Verified')
  }
  if (features.includes(PropertyFeatures.AIRBNB_FRIENDLY)) {
    other.push('Airbnb Friendly')
  }
  if (features.includes(PropertyFeatures.NO_BREED_RESTRICTIONS)) {
    other.push('No Breed Restrictions')
  }
  if (features.includes(PropertyFeatures.NEW_CONSTRUCTION)) {
    other.push('New Construction')
  }
  if (maxDays) {
    other.push('Posted Today')
  }
  if (hasImages) {
    other.push('With photos')
  }
  if (minSquareFeet) {
    other.push('Square feet')
  }
  if (hideNoVacancy) {
    other.push('Hide No Vacancy')
  }
  if (availableBefore) {
    other.push('Available now')
  }
  if (maxPricePerBedroomPercentile === 'p50') {
    other.push('Cheap')
  }
  if (minPricePerBedroomPercentile === 'p75') {
    other.push('Luxury')
  }

  return other
}
